<template>
  <div class="room-sticker-modal-component">
    <div class="room-sticker-modal">
      <RoomStickerList />
      <button class="room-sticker-button" @click="removeSticker()">{{ $t("sticker.erase") }}</button>
      <button v-if="hasEmceeRole()" class="room-sticker-button" @click="removeAllSticker()">{{ $t("sticker.eraseAll") }}</button>
    </div>
  </div>
</template>

<script>
import RoomStickerList from '@/components/Room/Sticker/List'
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomStickerModal',
  components: {
    RoomStickerList
  },
  computed: {
    ...mapGetters('user', [
        'me',
        'hasEmceeRole'
    ]),
  },
  methods: {
    ...mapActions('sticker', [
      'changeRoomUserSticker',
      'changeAllRoomUserSticker'
    ]),

    removeSticker() {
      this.changeRoomUserSticker(
        {
          userId : this.me.userId,
          stickerId : null
        }
      )
    },
    removeAllSticker() {
      if (this.hasEmceeRole()) {
        this.changeAllRoomUserSticker({stickerId : null})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-sticker-modal-component {
  overflow-y: auto;
}
.room-sticker-modal {
  height: max-content;
  border-radius: 2px;
  background-color: #f5f5f5;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.room-sticker-button {
  width: 100%;
  height: 40px;
  font-size: 12px;
  font-weight: 700;
  color: #666;
  transition: 0.1s ease-out;
  &:hover {
    background-color: #fff;
  }
}
</style>